import { useSelector } from "react-redux";
import React from "react";
import { Route } from "react-router-dom";
import Protected from "../components/Protected";
import AdminProtected from "../components/AdminProtected";
import Customers from "../pages/Admin-pages/CustomerAdmin/Customers";
import CustomerEdit from "../pages/Admin-pages/CustomerAdmin/CustomerEdit";
import CustomerSub from "../pages/Admin-pages/CustomerAdmin/CustomerSub";
import CustomerRelationships from "../pages/Admin-pages/CustomerAdmin/CustomerRelationships";
// import CustomerAdd from "../pages/Admin-pages/CustomerAdmin/Customeradd";
// import CustomerContactAdd from "../pages/Admin-pages/CustomerAdmin/CustomerContactAdd";
// import CustomerContactEdit from "../pages/Admin-pages/CustomerAdmin/CustomerContactEdit";
const CustomerRoutes = () => {
  // eslint-disable-next-line no-unused-vars
  const userInfo = useSelector((state) => state?.user);
  const routes = [
    <Route
      key="customer-route-1"
      path="/admin-manager/customers"
      element={
        <Protected>
          <AdminProtected access={true}>
            <Customers />
          </AdminProtected>
        </Protected>
      }
    />,
    // <Route
    //   key="customer-route-2"
    //   path="/admin-manager/customers/add-customer"
    //   element={
    //     <Protected>
    //       <AdminProtected access={true}>
    //         <CustomerAdd />
    //       </AdminProtected>
    //     </Protected>
    //   }
    // />,
    <Route
      key="customer-route-3"
      path="/admin-manager/customers/profile/:id"
      element={
        <Protected>
          <AdminProtected access={true}>
            <CustomerEdit />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="customer-route-4"
      path="/admin-manager/customers/sub/:id"
      element={
        <Protected>
          <AdminProtected access={true}>
            <CustomerSub />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="customer-route-5"
      path="/admin-manager/customers/relationships/:id"
      element={
        <Protected>
          <AdminProtected access={true}>
            <CustomerRelationships />
          </AdminProtected>
        </Protected>
      }
    />,
    // <Route
    //   key="customer-route-6"
    //   path="/admin-manager/customers/relationships/:r_id/add-contact/:id"
    //   element={
    //     <Protected>
    //       <AdminProtected access={true}>
    //         <CustomerContactAdd />
    //       </AdminProtected>
    //     </Protected>
    //   }
    // />,
    // <Route
    //   key="customer-route-6"
    //   path="/admin-manager/customers/relationships/:r_id/edit-contact/:id/:mainID"
    //   element={
    //     <Protected>
    //       <AdminProtected access={true}>
    //         <CustomerContactEdit />
    //       </AdminProtected>
    //     </Protected>
    //   }
    // />,
  ];
  return routes;
};
export default CustomerRoutes;
